import React, {useEffect, useMemo, useState} from 'react'
import {useSelector, useDispatch} from 'react-redux'
import {useLocation} from 'react-router-dom'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import DeleteConfirmationPopup from '../../../../../../Components/DeleteConfirmationPopup'
import {GeneralDataOFLoginUser} from '../../../../../../Utils/Auth'
import {AuthenticateUser} from '../../../../../../Utils/_helpers/RoleAndPermission'
import {
  DeletePriceRateSuperAdmin,
  GetPriceRuleList,
  UpdateCommisionRateSuperAdmin,
} from '../../../../Setup/GlobalRateCard/GlobalRateCardSlice/GlobalRateCardSlice'
import AddNewPriceRule from '../../../../Setup/GlobalRateCard/modal/AddNewPriceRule'

const PriceRuleForStaffAccount = () => {
  const param: any = useLocation()

  const isUserWhiteLabel = GeneralDataOFLoginUser()?.isWhiteLabelUser === true
  const Role = GeneralDataOFLoginUser()?.role

  const ProfileDetatileState = useSelector((state: any) => state?.ProfileData?.ProfileData?.user)

  const [percentage, setPercentage] = useState(ProfileDetatileState?.commissionRate)

  const PriceRateList = useSelector((state: any) => state?.priceRules?.RateCardList)

  const stafflist = useSelector((state: any) => state?.StaffAccount?.staffAccountList?.items)

  const dispatch = useDispatch()

  useEffect(() => {
    if (!isUserWhiteLabel) {
      dispatch(GetPriceRuleList({accountId: ProfileDetatileState?.accountId}))
      setPercentage(
        stafflist?.find((key: any) => key?._id === ProfileDetatileState?._id)?.commissionRate
      )
    } else {
      dispatch(GetPriceRuleList({accountId: ProfileDetatileState?.accountId}))
    }
  }, [])

  const updateComission = () => {
    dispatch(
      UpdateCommisionRateSuperAdmin({
        userId: ProfileDetatileState?._id,
        commissionRate: percentage,
      })
    )
  }

  return (
    <>
      <div className='card mb-0'>
        <div className='card-header card-header-stretch border-bottom-0'>
          <div className='card-title d-flex align-items-center'>
            <h3 className='fw-bolder m-0 text-gray-800'>Price Rules</h3>
          </div>
          <div className='card-toolbar m-0'>
            {!isUserWhiteLabel &&
              Role == ('superAdmin' || 'subAdmin') &&
              (ProfileDetatileState?.role == 'sales' ||
                ProfileDetatileState?.role == 'staffAdmin') && (
                <div className='d-flex gap-3 align-items-center'>
                  <input
                    className='form-control-solid form-control form-control-sm'
                    name='percentage'
                    value={percentage}
                    onChange={(e: any) => setPercentage(e.target.value)}
                  />
                  <button onClick={updateComission} className='btn btn-primary'>
                    Update
                  </button>
                </div>
              )}
          </div>
        </div>
        <div className='card-body pt-2'>
          <div className='tab-content'>
            <div className='table-responsive'>
              <table className='table table-row-dashed table-row-gray-300 align-middle gs-0 gy-4'>
                <thead>
                  <tr className='fw-bold text-muted text-uppercase'>
                    <th>Type</th>
                    <th>Credit From</th>
                    <th>Credit TO</th>
                    {param?.pathname !== '/staff-profile/credits' && <th>Cost price</th>}
                    <th>Final Price</th>
                    {!isUserWhiteLabel && <th>commission</th>}
                  </tr>
                </thead>
                <tbody className='text-gray-600'>
                  {PriceRateList?.map((data: any, id: number) => (
                    <tr key={id}>
                      <td>
                        <span className='badge badge-light-info'>{data?.type}</span>
                      </td>
                      <td>{data?.creditstartrange}</td>
                      <td>{data?.creditendrange}</td>

                      <td>${data?.finalPrice}</td>

                      {!isUserWhiteLabel && (
                        <td>
                          $
                          {(
                            data?.finalPrice *
                            (ProfileDetatileState?.commissionRate / 100)
                          ).toFixed(4)}
                        </td>
                      )}
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}

export default PriceRuleForStaffAccount
